import * as Cookie from './cookie';

let types = {
        info: { name: 'info', level: 2 },
        trace: { name: 'trace', level: 0 },
        warn: { name: 'warn', level: 3 },
        debug: { name: 'debug', level: 1 },
        error: { name: 'error', level: 4 },
        fatal: { name: 'fatal', level: 5 }
    }
let elmahLevel = 'warn';

function post(data) {

    $.ajax({
        url: 'https://micuenta.lanacion.com.ar' + '/ln-log',
        type: 'POST',
        data: JSON.stringify(data),
        async: true,
        crossDomain: true,
        xhrFields: {
            withCredentials: true
        }

    });
}
export const Muestreo =()  => { 
    try {
        var ytr_arrayUse = ["3785852", "3097523", "1682002"];
        //desa  ytr_arrayUse = ["3141092"];
        var ytr_userId = Cookie.LeerCookie('usuario%5Fid');
        if (ytr_userId != null && ytr_userId && ytr_arrayUse.indexOf(ytr_userId) > -1 )
        {
            console.log('gsdsf5d34');
            Error("User - " + ytr_userId+" - Cookies:" + document.cookie.split(';').length + " size:" + document.cookie.length);
        }
    } catch (ex) {
        console.log(ex);
    }
};

function log(type, message, ex) {
    try
    {

        if (ex != null && typeof ex  == "object")
        {
            ex = JSON.stringify(ex);
        }

        var values = {
            type: type,
            message: message,
            exception: ex
        };

        if (types[type].level >= types[elmahLevel].level) {
            post(values);
        }
    }catch(exp)
    { 
        console.log('Error logueando');
    }

    return true;
};

export const Error = (message, ex)  => { 
    return log(types.error.name, message, ex);
};

    export const Info = (message, ex)  => { 
    return log(types.info.name, message, ex);
};

export const Trace =  (message, ex)  => { 
    return log(types.trace.name, message, ex);
};

export const Warn = (message, ex)  => { 
    return log(types.warn.name, message, ex);
};

export const Debug = (message, ex)  => { 
    return log(types.debug.name, message, ex);
};

export const Fatal = (message, ex) => { 
    return log(types.fatal.name, message, ex);
};
    
export const Exception = (message, ex) => { 
    return log(types.fatal.name, message, ex);
};









// WEBPACK FOOTER //
// ./Statics/scripts/common/logger.js